/**
 * @file map 引用出口
 * @author Auto Generated by IconPark
 */
import { toIconNameLowerMap } from '../utils';

import loadMap_app_line from './loadMap_app_line';
import loadMap_app_s_a from './loadMap_app_s_a';
import loadMap_app_surface from './loadMap_app_surface';
import loadMap_attachment_format from './loadMap_attachment_format';
import loadMap_base from './loadMap_base';
import loadMap_bd from './loadMap_bd';
import loadMap_client from './loadMap_client';
import loadMap_cloud_store_color from './loadMap_cloud_store_color';
import loadMap_controls from './loadMap_controls';
import loadMap_custom_line from './loadMap_custom_line';
import loadMap_custom_surface from './loadMap_custom_surface';
import loadMap_dh from './loadMap_dh';
import loadMap_edit_detail_form from './loadMap_edit_detail_form';
import loadMap_fc_and_apt from './loadMap_fc_and_apt';
import loadMap_form_advanced_controls from './loadMap_form_advanced_controls';
import loadMap_invoiceCloud from './loadMap_invoiceCloud';
import loadMap_invoiceCloud_color from './loadMap_invoiceCloud_color';
import loadMap_knowledge_color from './loadMap_knowledge_color';
import loadMap_logo from './loadMap_logo';
import loadMap_message_line from './loadMap_message_line';
import loadMap_message_module_color from './loadMap_message_module_color';
import loadMap_message_surface from './loadMap_message_surface';
import loadMap_module from './loadMap_module';
import loadMap_rate from './loadMap_rate';
import loadMap_reimbursement_line from './loadMap_reimbursement_line';
import loadMap_reimbursement_surface from './loadMap_reimbursement_surface';
import loadMap_rich_text from './loadMap_rich_text';
import loadMap_sap_surface from './loadMap_sap_surface';
import loadMap_supplement from './loadMap_supplement';
import loadMap_task_color from './loadMap_task_color';
import loadMap_tenant from './loadMap_tenant';
import loadMap_ESB_integration from './loadMap_ESB_integration';
import loadMap_module_color from './loadMap_module_color';
import loadMap_IM_terminal from './loadMap_IM_terminal';
import loadMap_mgt_dh from './loadMap_mgt_dh';

export const ICON_MAP: { [key: string]: () => Promise<any> } = {
  ...loadMap_app_line,
  ...loadMap_app_s_a,
  ...loadMap_app_surface,
  ...loadMap_attachment_format,
  ...loadMap_base,
  ...loadMap_bd,
  ...loadMap_client,
  ...loadMap_cloud_store_color,
  ...loadMap_controls,
  ...loadMap_custom_line,
  ...loadMap_custom_surface,
  ...loadMap_dh,
  ...loadMap_edit_detail_form,
  ...loadMap_fc_and_apt,
  ...loadMap_form_advanced_controls,
  ...loadMap_invoiceCloud,
  ...loadMap_invoiceCloud_color,
  ...loadMap_knowledge_color,
  ...loadMap_logo,
  ...loadMap_message_line,
  ...loadMap_message_module_color,
  ...loadMap_message_surface,
  ...loadMap_module,
  ...loadMap_rate,
  ...loadMap_reimbursement_line,
  ...loadMap_reimbursement_surface,
  ...loadMap_rich_text,
  ...loadMap_sap_surface,
  ...loadMap_supplement,
  ...loadMap_task_color,
  ...loadMap_tenant,
  ...loadMap_ESB_integration,
  ...loadMap_module_color,
  ...loadMap_IM_terminal,
  ...loadMap_mgt_dh
}

export default ICON_MAP;

export const ICON_NAMES_LOWER_MAP = toIconNameLowerMap(ICON_MAP);
